"use strict";
/** @jsxRuntime classic */
/** @jsx jsx */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = exports.MENU_ITEM_TEST_ID = void 0;
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
var jangle_1 = require("../../styles/Jangle/jangle");
exports.MENU_ITEM_TEST_ID = "menu-item";
/**
 * This component renders a MenuItem as a ThemeUI Link (i.e. an HTML anchor) with the given href.
 * If using in a more JS-driven context (i.e. Next.js), pass an appropriate onClick function to handle navigation.
 */
var MenuItem = function (_a) {
    var children = _a.children, href = _a.href, onClick = _a.onClick, isActive = _a.isActive;
    return (theme_ui_1.jsx(theme_ui_1.Link, { "data-testid": exports.MENU_ITEM_TEST_ID, href: href, sx: { textDecoration: "none" }, onClick: onClick },
        theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
                transform: "skewX(-" + jangle_1.JANGLE_DEGREES + "deg)",
                backgroundColor: isActive ? theme_1.theme.colors.grey1000 : "inherit",
                p: "0 32px",
                ":hover": {
                    backgroundColor: theme_1.theme.colors.grey1000,
                },
            } },
            theme_ui_1.jsx(theme_ui_1.Text, { as: "p", sx: { transform: "skewX(" + jangle_1.JANGLE_DEGREES + "deg)" }, variant: "text.p" }, children))));
};
exports.MenuItem = MenuItem;
